import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";

type Props = {
  message: string;
  onRetry?: () => void;
  surface?: "light" | "dark";
};

export function FormError({ message, onRetry, surface = "light" }: Props) {
  const { t } = useTranslation("common");
  const tone = surface === "dark" ? "!text-white" : "!text-error";
  return (
    <p role="alert" className={`flex flex-wrap items-center gap-3 t-body-blue ${tone}`}>
      <span>{message}</span>
      {onRetry ? (
        <Button variant="link" surface={surface} leftIcon="refresh" onClick={onRetry}>
          {t("tryAgain")}
        </Button>
      ) : null}
    </p>
  );
}
